window["engagement-finder"] =  window['engagement-finder']  ||  {}
export default {
  name: "RejectedByManagerPage",
  components: {
    ...window["engagement-finder"].default
  },
  data: () => ({
    language: "fr"
  })
};